var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"home-extra-button",attrs:{"to":_vm.link}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.image,"alt":_vm.label}}),_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }